import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
const BackSections = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const handleClick = () => {
    navigate(sessionStorage.getItem("PREV_ROUTE"));
  };
  const translation = getTranslationData();
  return (
    <section
      className={`py-xl-3 pt-1 ${location.pathname === "/card" || location.pathname === "/orders" ||
        location.pathname === "/myprofile"
        // || location.pathname==="/order-Confirmation"
        ? "pb-2"
        : "pb-4"
        }  desktop-hide backButton mar-4 mb-4`}
    >
      <div className="container-fluid position-relative">
        <div className="m-xl-n3 m-md-n2 m-n1">
          <div className="p-md-2 p-1 back position-relative">
            <div className="position-absolute start-0" onClick={handleClick}>
              <i className="fa-solid fa-chevron-left clr-black-blk"></i> &nbsp;
              <span className="fw-bold">{translation?.back}</span>
            </div>
            {location.pathname === "/orders" ? (
              <div className="text-center fw-bold">
                {translation?.orderDetails}

              </div>
            ) : location.pathname === "/card" ? (
              <div className="text-center fw-bold">{translation?.checkout}</div>
              // ) : location.pathname==="/order-Confirmation" ? (
              //   <div className="text-center fw-bold">{translation?.checkout}</div>
            )
              : location.pathname === "/myprofile" ? (
                <div className="text-center fw-bold">MyAccount</div>
                // ) : location.pathname==="/order-Confirmation" ? (
                //   <div className="text-center fw-bold">{translation?.checkout}</div>
              )

                : (
                  ""
                )}
          </div>
        </div>
      </div>
    </section>
  );
};
export default BackSections;
